import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  CircularProgress,
} from "@mui/material";

const BondArchivesLibertyConfirmDialog = ({
  libertyConfirmDialogOpen,
  setLibertyConfirmDialogOpen,
  setSelectedBondToLiberty,
  isMarkingLibertyComplete,
  handleLibertyBypassConfirm,
}) => {
  return (
    <Dialog
      open={libertyConfirmDialogOpen}
      onClose={() => !isMarkingLibertyComplete && (setLibertyConfirmDialogOpen(false), setSelectedBondToLiberty(null))}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Mark Liberty Complete</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to mark this bond as Liberty complete? This action will prevent this bond from being released to liberty in the next run.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setLibertyConfirmDialogOpen(false);
            setSelectedBondToLiberty(null);
          }}
          color="primary"
          disabled={isMarkingLibertyComplete}
        >
          Cancel
        </Button>
        <Button
          onClick={handleLibertyBypassConfirm}
          color="success"
          variant="contained"
          disabled={isMarkingLibertyComplete}
          startIcon={isMarkingLibertyComplete ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isMarkingLibertyComplete ? "Marking..." : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

BondArchivesLibertyConfirmDialog.propTypes = {
  libertyConfirmDialogOpen: PropTypes.bool.isRequired,
  setLibertyConfirmDialogOpen: PropTypes.func.isRequired,
  setSelectedBondToLiberty: PropTypes.func.isRequired,
  isMarkingLibertyComplete: PropTypes.bool.isRequired,
  handleLibertyBypassConfirm: PropTypes.func.isRequired,
};

export default BondArchivesLibertyConfirmDialog;
